import React from 'react';
import MainInfoTracLayout from '../../../components/Layout/Main';
import AccountManagementProvider from '../../../context/accountManagement';
import Content from '../../../components/Pages/AccountManagement/AccountDetail';
import { displayName } from '../../../../App';

function AccountManagementAccountDetail() {
  document.title = `${displayName}: Account Detail`;

  return (
    <MainInfoTracLayout className="min-h-screen">
      <AccountManagementProvider>
        <Content />
      </AccountManagementProvider>
    </MainInfoTracLayout>
  );
}

export default AccountManagementAccountDetail;
